import React, { useCallback, useEffect, useState } from "react";
import { useTabs } from "../../hooks/lib/useTabs";
import donation from "../../assets/img/community/donations.webp";
import { Link } from "react-router-dom";
import { useLoader } from "../../context/LoaderContext";
// import { IBuildingForFutureTabData } from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/custom/useToast";
import {
  fetchMultiYearCommitmentsTab,
  fetchOneTimeDonationsTab,
  fetchPartnershipsTab,
} from "../../api/BuildingForFutureApi";
import { getVisibleTabs, truncateText } from "../../exports/functions";
import { useMobile } from "../../hooks/custom/useMobile";
import TabSidebar from "../TabSidebar";

export const UniversityTab = () => {
  useTabs();
  const { setLoading } = useLoader();
  // const [oneTimeDonationsData, setOneTimeDonationsData] = useState<
  //   IBuildingForFutureTabData[]
  // >([]);
  // const [multiYearCommitmentsData, setMultiYearCommitmentsData] = useState<
  //   IBuildingForFutureTabData[]
  // >([]);
  // const [partnershipsData, setPartnershipsData] = useState<
  //   IBuildingForFutureTabData[]
  // >([]);
  const isMobile = useMobile();
  const [activeTab, setActiveTab] = useState<string>("#td_tab_1");
  const [openSidebar, setOpenSidebar] = useState(false);

  const [allTabData, setAllTabData] = useState<{
    [key: string]: any[];
  }>({});

  const allTabs = React.useMemo(
    () => [
      { id: "#td_tab_1", label: "One-Time Donations" },
      { id: "#td_tab_2", label: "Multi-Year Commitments" },
      { id: "#td_tab_3", label: "Partnerships" },
    ],
    [], 
  );

  const visibleTabs = React.useMemo(() => {
    return getVisibleTabs(allTabs, activeTab, isMobile ? 2 : 4);
  }, [allTabs, activeTab, isMobile]);

  const fetchTabData = useCallback(async () => {
    try {
      setLoading(true);
      let oneTimeDonations;
      let multiYearCommitments;
      let partnerships;

      oneTimeDonations = await fetchOneTimeDonationsTab();

      multiYearCommitments = await fetchMultiYearCommitmentsTab();

      partnerships = await fetchPartnershipsTab();

      setAllTabData({
        "#td_tab_1": oneTimeDonations,
        "#td_tab_2": multiYearCommitments,
        "#td_tab_3": partnerships,
      });
    } catch (error: any) {
      dynamicFailed(error.response?.data?.error?.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [setLoading]);

  useEffect(() => {
    fetchTabData();
  }, [fetchTabData]);

  const handleTabClick = (hash: string) => {
    setActiveTab(hash);
  };

  const tabData = allTabData[activeTab] || [];

  return (
    <>
      <section id="ways-to-give">
        <div className="container">
          <div
            className="td_section_heading td_style_1 wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <h2 className="td_section_title td_fs_48 mb-0">Ways to Give</h2>
            <div className="td_height_30 td_height_lg_30" />
          </div>
          <div className="row td_gap_y_50">
            {/* content */}
            <div className="td_course_details">
              {/* tabs */}
              <div className="td_tabs td_style_1 td_mb_50">
                <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_20 td_heading_color align-items-center justify-content-between">
                  <div className="td_tab_links td_style_2">
                    {visibleTabs.map((tab) => (
                      <li
                        key={tab.id}
                        className={activeTab === tab.id ? "active" : ""}
                      >
                        <a
                          href={tab.id}
                          onClick={() => handleTabClick(tab.id)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={tab.label}
                        >
                          {truncateText(tab.label, isMobile ? 10 : 30)}
                        </a>
                      </li>
                    ))}
                  </div>
                  {isMobile && (
                    <li>
                      <div className="course_sidebar_toggle_wrapper">
                        <button
                          className="course_sidebar_toggle mt-1"
                          onClick={() => setOpenSidebar(true)}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                          {/* <span></span>
                  <span></span>
                  <span></span> */}
                        </button>
                      </div>
                    </li>
                  )}
                </ul>
                <div className="td_tab_body td_fs_18">
                  <div className="td_tab active" id="td_tab_1">
                    <div style={{ display: "flex", gap: "25px" }}>
                      <div
                        className="mb-0 custom-text-p"
                        style={{ flex: 1 }}
                      >
                        {tabData.map((data, index) => (
                          <>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: data?.description,
                              }}
                            />
                            {index !== tabData.length - 1 && (
                              <div className="td_height_30 td_height_lg_30" />
                            )}
                          </>
                        ))}
                      </div>
                      <div>
                        <img
                          src={donation}
                          alt="donation"
                          width="150px"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="td_tab" id="td_tab_2">
                    <div style={{ display: "flex", gap: "25px" }}>
                      <div
                        className="mb-0 custom-text-p"
                        style={{ flex: 1 }}
                      >
                        {tabData.map((data, index) => (
                          <>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: data?.description,
                              }}
                            />
                            {index !== tabData.length - 1 && (
                              <div className="td_height_30 td_height_lg_30" />
                            )}
                          </>
                        ))}
                      </div>
                      <div>
                        <img
                          src={donation}
                          alt="donation"
                          width="150px"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="td_tab" id="td_tab_3">
                    <div style={{ display: "flex", gap: "25px" }}>
                      <div
                        className="mb-0 custom-text-p"
                        style={{ flex: 1 }}
                      >
                        {tabData.map((data, index) => (
                          <>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: data?.description,
                              }}
                            />
                            {index !== tabData.length - 1 && (
                              <div className="td_height_30 td_height_lg_30" />
                            )}
                          </>
                        ))}
                      </div>
                      <div>
                        <img
                          src={donation}
                          alt="donation"
                          width="150px"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container d-flex justify-content-center">
          <Link
            to="/contact"
            className="td_btn td_style_1 td_radius_10 custom-td_style_1 td_medium"
          >
            <span className="td_btn_in custom_td_btn_in">
              <span>For More Information, Please Contact Us Now </span>
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1575 4.34302L3.84375 15.6567"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </Link>
        </div>
        <div className="td_height_120 td_height_lg_40" />
      </section>
      <TabSidebar
        title="Ways to Give"
        tabs={allTabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      />
    </>
  );
};
